<template lang="pug">
#ourWork.container-fluid(v-bind:class="{mobile: isMobile}")
  #Header.row.valign-wrapper(v-if="!isMobile")
    .col.s12.center
      br
      img#mainLogo(src="../assets/desktop/landing/2024/Desktop_HomePage_Logo.png" v-on:click="$router.push('/#app')")
  #content.relative()
    .row(v-if="isMobile" style="padding-top:28vw")
    .row.center(v-if="!project")
      //- p.Fjalla(style="font-size:150%; margin: -5px") THIS IS WHAT WE DO.
      p.Fjalla.normalSize(style="margin: -5px; margin-bottom:5px") CULTURES HAVE BLENDED.
      p.Fjalla.normalSize(style="margin: -5px; margin-bottom:5px") YOUR BRAND'S WORK SHOULD REFLECT THAT.
    .row(v-if="project" v-for="p in infoProjects[project]").center
      p.Fjalla.normalSize.Title {{p.Title}}
      br
      .row(v-for="c in p.content")
        div(v-if="c.type=='video'")
          iframe.youtube(:src="c.url" frameborder="0" allowfullscreen allow="fullscreen")
        div(v-if="c.type=='slides'")
          .slides(v-bind:class="{mobile: isMobile}")
            i.material-icons.leftA.showHand(@click="slideCounter > 0 ? slideCounter-- : slideCounter++" style="font-size:150%") chevron_left
            img.image(:src="c.pictures[0]")
            img.image.slide(v-for="(s, i) in c.pictures" :src="s" v-bind:class="{active: i == slideCounter % c.pictures.length}")
            i.material-icons.rightA.showHand(@click="slideCounter++" style="font-size:150%") chevron_right
        div(v-if="c.type=='image'")
          img.image(:src="c.src")
        div(v-if="c.type=='imagesCols'").imgCols
          .col(v-for="p in c.pictures" v-bind:class="{s3:c.cols == 4, s4:c.cols == 3}")
            img.image(:src="p")
        div(v-if="c.type=='text'")
          p.Montserrat.smallestSize.textW(v-html="c.text")
        div(v-if="c.type=='press'").press
          p.Montserrat.smallestSize.textW {{c.title}}
          p.Montserrat.smallestSize.textW
            a(v-for="(l, j) in c.links" :href="l.href" target="_blank") {{l.name}}
              //span(v-if="j != c.links.length-1")  |
        div(v-if="c.type=='radio'").Montserrat.radio
          //p.smallestSize.textW.center Radio
          //br
          .container
            .col.s6(v-for="co in c.comercial")
              p.smallestSize(v-on:click="playSound(co.url, co.name);" v-bind:class="{active: co.name == selectedRadio}")
                img(src="../assets/play-arrow.jpg")
                |  {{co.name}}
    .row#works(v-if="!isMobile").center-align
      .col.s4.m3.relative#work(v-for="w in works" v-on:click="$router.push('/work/' + w.project); project = w.project;")
        img(v-bind:src="w.image")
        p.Fjalla.smallestSize.title.center {{w.project}}
        a(:href="'/work/' + w.project" style="opacity:0")
    .row#worksMobile(v-if="isMobile")
      .col.s6.relative#work.mobile(v-for="w in works" v-on:click="$router.push('/work/' + w.project); project = w.project;")
        img(v-bind:src="w.image")
        p.Fjalla.smallestSize.title.center {{w.project}}
        a(:href="'/work/' + w.project" style="opacity:0")
</template>

<script>
window.$ = require('jquery');
var worksData = require('../../static/works.js');
//Radio
var audioElement = document.createElement('audio');
var lastSrc = "";
window.playSound = function(src, obj){
  console.log(obj)
  //$(".radio p").removeClass("active");
  if(src != lastSrc) {
    audioElement.setAttribute('src', src);
    audioElement.play();
    //$(obj).addClass("active");
    lastSrc = src;
  }else{
    lastSrc = "";
    audioElement.pause();
  }
}
audioElement.oncanplay = function() {
    audioElement.play();
};
export default {
  data(){
    return {
      isMobile: false,
      project: "",
      slideCounter: 0,
      infoProjects: worksData,
      selectedRadio: "",
      works:[
        {project: "GOOGLE IWD 2021", image:"/static/works/thumbnail_IWD_Thumbnail.jpg"},
        {project: "GOOGLE YEAR IN SEARCH 2020", image:"/static/works/YearInSearch_Thumbnail.jpg"},
        {project: "GOOGLE SEARCHING FOR A WAY", image:"/static/works/Google_Thumbnail.jpg"},
        {project: "VRBO", image:"/static/works/Vrbo_Thumbnail.jpg"},
        {project: "LYFT", image:"/static/works/LNH_Lyft_Thumbnail.png"},
        {project: "SAN DIEGO WAVE FÚTBOL CLUB", image:"/static/works/SDWave_Thumbnail.jpg"},
        {project: "AIRBNB", image:"/static/works/LNH_Airbnb_Thumbnail.png"},
        {project: "TURBOTAX", image:"/static/works/TurboTax.jpg"},
        {project: "BUD LIGHT PARTY", image:"/static/works/BudLight_Thumb.png"},
        {project: "TARGET EASTER", image:"/static/works/Target_Thumbnail.jpg"},
        {project: "TARGET BABY", image:"/static/works/Target_Thumb.png"},
        {project: "THE LETGO COMMERCIALIZER", image:"/static/works/LetGo_Thumb.png"},
        {project: "DOMESTIC WORKERS", image:"/static/works/Trabajadoras_Thumbnail_LNH.jpg"},
        {project: "VW GOAL CELEBRATION CAMP", image:"/static/works/VW_Thumb.png"},
        {project: "DOMINO’S PIZZA TURNAROUND", image:"/static/works/Dominos_Thumb.png"},
        {project: "RON MONTERO", image:"/static/works/RonMonteroThumbnail.png"},
        {project: "YOUTUBE - COPA90", image:"/static/works/Youtube_Thumb.png"},
        {project: "BURGER KING", image:"/static/works/BurgerKing_Thumb.png"},
        {project: "CUERVO GAMES", image:"/static/works/CuervoGames_ThumbForWeb.png"},
        {project: "KRAFT MACARONI & CHEESE", image:"/static/works/Kraft_Thumb.png"},
        {project: "SPECIALIZED", image:"/static/works/Specialized_Thumb.png"},
        {project: "YOU ARE FALLON", image:"/static/works/YouAreFallon_Thumb.png"},
        {project: "JETBLUE", image:"/static/works/JetBlue_Thumb.png"},
        {project: "HOLIDAY INN EXPRESS", image:"/static/works/HolidayInn_Thumb.png"},
        {project: "EQUINOX", image:"/static/works/Equinox_Thumb.png"},
        {project: "ELF YOURSELF", image:"/static/works/ElfYourself_Thumb.png"},
        {project: "NASCAR", image:"/static/works/Nascar_Thumb.png"},
        {project: "HEWLETT PACKARD", image:"/static/works/HP_Thumb.png"},
        {project: "SATURN", image:"/static/works/Saturn_Thumb.png"},
        {project: "CUENTAS", image:"/static/works/Cuentas_Thumb.png"},
        {project: "WÜSTHOFF KNIVES", image:"/static/works/Wustoff_Thumb.png"},
        {project: "CARHARTT", image:"/static/works/Carhart_Thumb.png"},
        {project: "NIKE", image:"/static/works/Nike_Thumb.png"},
        {project: "GREEN GARAGE", image:"/static/works/GreenGarage_Thumb.png"},
        {project: "CONSUMER REPORTS", image:"/static/works/ConsumerReports_Thumb.png"},
      ]
    }
  },
  mounted(){
    this.isMobile = window.screen.availWidth < 740;
    this.project = this.$route.params.work;
    setTimeout(()=>{
      //console.log($, $("#navbar a"))
      $("#navbar a").removeClass('active');
      $("#A-Our-Work").addClass('active');
    }, 100);
    setInterval(()=>{
      this.slideCounter++
    }, 5000)
  },
  methods:{
    playSound(src, obj){
      this.selectedRadio = obj;
      playSound(src, obj);
    }
  },
  watch: {
   '$route' (to, from) {
     this.project = this.$route.params.work || "";
   }
 }
}
</script>

<style lang="sass" scoped>
#ourWork
  font-size: 2.5vw
  &.mobile
    font-size: 5.5vw
#Header
  height: calc(100vw / 16 * 3.1)
  background: black
  img
    width: 21vw
#content
  padding-top: 30px
  .Title
    position: relative
    &:after
      content: ''
      position: absolute
      width: 33vw
      bottom: -30px
      left: 50%
      border-bottom: 0.3vw solid #00FFFF
      z-index: 90
      transform: translate(-50%,0)
  p
    line-height: 1.3
#worksMobile
  margin-bottom: 0px
  #work
    max-height: 49.7vw
    height: 49.7vw
#works
  margin-bottom: 0px
#work
  max-height: 24.9vw
  height: 24.9vw
.youtube
  width: 75vw
  height: calc(75vw / 9 * 5)
.image
  max-width: 100%
.textW
  padding-left: 8vw
  padding-right: 8vw
  font-weight: normal
.slides
  position: relative
  img:first-of-type
    opacity: 0
  .slide
    position: absolute
    left: 50%
    top: 0
    transform: translate(-50%,0)
    opacity: 0
    transition: opacity 0.7s
    &.active
      opacity: 1
  i
    position: absolute
    z-index: 10000
    &.leftA
      top: 50%
      left: 5vw
      transform: translate(0%, -50%)
    &.rightA
      top: 50%
      right: 5vw
      transform: translate(0%, -50%)
  &.mobile
    img:first-of-type
      display: none
    i
      display: none
    .slide
      position: relative
      left: 0
      top: 0
      transform: translate(0,0)
      opacity: 1
      &.active
        opacity: 1

.press
  a
    color: rgba(92, 90, 90, 0.6)
    font-size: 80%
    padding-left: 10px
    padding-right: 10px
    border-style: solid
    border: 0px
    border-right: 1px solid #000
    &:last-of-type
      border-right: 0px solid #000
.radio
  text-align: left
  font-weight: 400
  img
    width: 1.5vw
    opacity: 0.5
  p.active, p:hover
    img
      opacity: 1
.imgCols
  .col
    padding: 10px
    //margin: 10px
  img
    width: 99%
</style>



// WEBPACK FOOTER //
// src/components/ourwork.vue